/**
 * Google EU User Consent Policy (EUUCP) — tylko strona polityki prywatności.
 * Baner cookie: tekst jest w Shopify Admin (Customer privacy) — NIE doklejamy nic do banera.
 */
(function () {
  var GOOGLE_PRIVACY_URL = 'https://business.safety.google/privacy/';
  var ATTR = 'data-lumly-euucp';

  var POLICY_HTML =
    '<div class="lumly-euucp-notice" ' + ATTR + '="1" style="margin:0 0 1.5rem;padding:1rem 1.25rem;border:1px solid #ddd;border-radius:8px;background:#f8f9fa;line-height:1.5">' +
    '<p style="margin:0 0 0.75rem"><strong>Reklamy, cookies i Google (ads personalization)</strong></p>' +
    '<p style="margin:0 0 0.75rem">Używamy plików cookies oraz identyfikatorów reklamowych (w tym identyfikatorów reklam mobilnych) do reklam spersonalizowanych (<strong>ads personalization</strong>) i niespersonalizowanych, a także do pomiaru konwersji i analityki — zgodnie z Twoimi wyborami w banerze zgody.</p>' +
    '<p style="margin:0">Informacje o tym, jak Google wykorzystuje dane osobowe: ' +
    '<a href="' + GOOGLE_PRIVACY_URL + '" target="_blank" rel="noopener noreferrer">https://business.safety.google/privacy/</a> (Google Business Data Responsibility Site).</p>' +
    '</div>';

  function enhancePolicy() {
    var path = (location.pathname || '').toLowerCase();
    if (path.indexOf('/policies/privacy-policy') === -1) return;
    if (document.querySelector('.lumly-euucp-notice')) return;
    var body =
      document.querySelector('.shopify-policy__body') ||
      document.querySelector('.shopify-policy__container .rte') ||
      document.querySelector('.shopify-policy__container');
    if (!body) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = POLICY_HTML;
    body.insertBefore(wrap.firstChild, body.firstChild);
  }

  function start() {
    enhancePolicy();
    [500, 1500, 3000].forEach(function (ms) {
      setTimeout(enhancePolicy, ms);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
